import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const Login = resolve => require(['../views/Login.vue'], resolve);
const Index = resolve => require(['../views/Index.vue'], resolve);


const Dashboard = resolve => require(['../views/Dashboard.vue'], resolve);
const Legal = resolve => require(['../views/Legal.vue'], resolve);

const Ordering = resolve => require(['../views/Ordering.vue'], resolve);


const ProjectRegistration = resolve => require(['../views/ProjectRegistration.vue'], resolve);
const ProjectRegistrationUpdate = resolve => require(['../views/ProjectRegistration.update.vue'], resolve);
const ProjectRegistrationInfo = resolve => require(['../views/ProjectRegistration.info.vue'], resolve);


const Account = resolve => require(['../views/Account.vue'], resolve);

const ProductNumber = resolve => require(['../views/ProductNumber.vue'], resolve);

const Certifications = resolve => require(['../views/Certifications.vue'], resolve);
const Certification = resolve => require(['../views/Certification.vue'], resolve);

const TechnologyPartners = resolve => require(['../views/TechnologyPartners.vue'], resolve);
const TechnologyPartner = resolve => require(['../views/TechnologyPartner.vue'], resolve);
const TechnologyPartnerUpdate = resolve => require(['../views/TechnologyPartner.update.vue'], resolve);
const TechnologyPartnerInfo = resolve => require(['../views/TechnologyPartner.info.vue'], resolve);

const Partners = resolve => require(['../views/Partners.vue'], resolve);
const PartnersSendEamil = resolve => require(['../views/Partners.sendEmail.vue'], resolve);
const Partner = resolve => require(['../views/Partner.vue'], resolve);

const Companys = resolve => require(['../views/Companys.vue'], resolve);
const Company = resolve => require(['../views/Company.vue'], resolve);

const Products = resolve => require(['../views/Products.vue'], resolve);
const Product = resolve => require(['../views/Product.vue'], resolve);

const Solutions = resolve => require(['../views/Solutions.vue'], resolve);
const Solution = resolve => require(['../views/Solution.vue'], resolve);

const Exhibitions = resolve => require(['../views/Exhibitions.vue'], resolve);
const Exhibition = resolve => require(['../views/Exhibition.vue'], resolve);

const SaleLeads = resolve => require(['../views/SaleLeads.vue'], resolve);
const SaleLeadsUpdate = resolve => require(['../views/SaleLeads.update.vue'], resolve);
const SaleLeadsInfo = resolve => require(['../views/SaleLeads.info.vue'], resolve);
const Learn = resolve => require(['../views/Learn.vue'], resolve);

const ProductCategory = resolve => require(['../views/ProductCategory.vue'], resolve);
const ProductModel = resolve => require(['../views/ProductModel.vue'], resolve);
const DocumentType = resolve => require(['../views/DocumentType.vue'], resolve);

const DocumentsProductCategory = resolve => require(['../views/DocumentsProductCategory.vue'], resolve);
const DocumentsProductModel = resolve => require(['../views/DocumentsProductModel.vue'], resolve);
const DocumentsDocumentType = resolve => require(['../views/DocumentsDocumentType.vue'], resolve);


const router = new Router({
    // mode: 'history',
    routes: [{
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/',   
        name: 'index',
        component: Index,
        redirect: '/dashboard',
        children: [{
            path: 'ordering',
            name: 'ordering',
            component: Ordering
        }, {
            path: 'projectRegistration',
            name: 'projectRegistration',
            component: ProjectRegistration
        }, {
            path: 'projectRegistrationUpdate',
            name: 'projectRegistration',
            props: (route) => ({ id: route.query.id }),
            component: ProjectRegistrationUpdate
        }, {
            path: 'projectRegistrationInfo',
            name: 'projectRegistration',
            props: (route) => ({ id: route.query.id }),
            component: ProjectRegistrationInfo
        }, {
            path: 'legal',
            name: 'legal',
            component: Legal
        }, {
            path: 'dashboard',
            name: 'dashboard',
            component: Dashboard
        }, {
            path: 'productNumber',
            name: 'productNumber',
            component: ProductNumber
        }, {
            path: 'certifications',
            name: 'certifications',
            component: Certifications
        }, {
            path: 'certification',
            name: 'certification',
            component: Certification
        }, {
            path: 'technologyPartners',
            name: 'technologyPartners',
            component: TechnologyPartners
        }, {
            path: 'technologyPartner',
            name: 'technologyPartner',
            component: TechnologyPartner
        }, {
            path: 'technologyPartnerUpdate',
            name: 'technologyPartner',
            props: (route) => ({ id: route.query.id }),
            component: TechnologyPartnerUpdate
        }, {
            path: 'technologyPartnerInfo',
            name: 'technologyPartners',
            props: (route) => ({ id: route.query.id }),
            component: TechnologyPartnerInfo
        }, {
            path: 'companys',
            name: 'companys',
            component: Companys
        }, {
            path: 'company',
            name: 'company',
            component: Company
        }, {
            path: 'products',
            name: 'products',
            component: Products
        }, {
            path: 'product',
            name: 'product',
            component: Product
        }, {
            path: 'solutions',
            name: 'solutions',
            component: Solutions
        }, {
            path: 'solution',
            name: 'solution',
            component: Solution
        }, {
            path: 'exhibitions',
            name: 'exhibitions',
            component: Exhibitions
        }, {
            path: 'exhibition',
            name: 'exhibition',
            component: Exhibition
        }, {
            path: 'account',
            name: 'account',
            component: Account
        }, {
            path: 'partner',
            name: 'partner',
            component: Partner
        }, {
            path: 'partners',
            name: 'partners',
            component: Partners
        }, {
            path: 'partnersSendEmail',
            name: 'partners',
            props: (route) => ({ id: route.query.id }),
            component: PartnersSendEamil
        }, {
            path: 'saleLeads',
            name: 'saleLeads',
            component: SaleLeads
        }, {
            path: 'saleLeadsUpdate',
            name: 'saleLeads',
            props: (route) => ({ id: route.query.id }),
            component: SaleLeadsUpdate
        }, {
            path: 'saleLeadsInfo',
            name: 'saleLeads',
            props: (route) => ({ id: route.query.id }),
            component: SaleLeadsInfo
        }, {
            path: 'learn',
            name: 'learn',
            component: Learn
        }, {
            path: 'productCategory',
            name: 'productCategory',
            component: ProductCategory
        }, {
            path: 'productModel',
            name: 'productModel',
            component: ProductModel
        }, {
            path: 'documentType',
            name: 'documentType',
            component: DocumentType
        },{
            path: 'documentsProductCategory',
            name: 'documentsProductCategory',
            component: DocumentsProductCategory
        }, {
            path: 'documentsProductModel',
            name: 'documentsProductModel',
            component: DocumentsProductModel
        }, {
            path: 'documentsDocumentType',
            name: 'documentsDocumentType',
            component: DocumentsDocumentType
        }]
    }
    ]
});
//路由守卫，在路径跳转前判断是否登录，登录前往主页面，未登录前往登录页面
router.beforeEach((to,from,next)=>{
    if(to.path!=='/login') {
        if(!localStorage.getItem("producttoken")) {
            next({path:"/login"});
        }else{
            next();
        }
    }
    next();
});
export default router;